import { render, staticRenderFns } from "./childrenTrain.vue?vue&type=template&id=49b3de0e&lang=pug"
import script from "./childrenTrain.vue?vue&type=script&lang=js"
export * from "./childrenTrain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports